module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASpJREFUOI2tlE2KhDAQhb+m+hJ1i4bs5jQBwUMJgT6NO8Fb5BSFs9BoNPEHZrIKWvl8r17FNzfLzKa0F5HXXf37Eewr4O2OdQ9MsNgMqH/EuwfGZkCDA/5JoQa32k0tuOrlM4XMPYwyovbBzKYzaBWYJ6vBrVA1WwM6g54rXA7GZliV0oxoAFqBrt7TU2CuKsq4fx7cqY4CmOyqfYgyqypWD/iHwL+uOvBwM1IwaX91a+rAHuJiNYeldTU+O2DqXwyZmh60ccQwbCMUHLRUky4VfgXYRiUlquyTjWFAOwqVBTC3p+aIMqDmwDOnntdU/kIFcGdrgR7f7er8nWVv0IxLcWaz3XqbVNb+QjugiLzMbEpfX+0CdKA/h8Qr41MfG2+ZleyQp7B4HJtfIyG1ITi3vDEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/incident_layer/ignition.png
// module id = 367
// module chunks = 0